import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  VendorPoItemsPage,
  loader as vendorPoItemsPageLoader,
} from "./pages/vendor/$vendorId/VendorPoItemsPage";
import { LoginPage } from "./_components/login/LoginPage";
import {
  PurchaseOrderItemExpand,
  loader as purchaseOrderItemExpandLoader,
} from "./pages/vendor/$vendorId/$purchaseOrderItemId/purchaseOrderItem/PurchaseOrderItemExpand";
import {
  VendorSelectionPage,
  loader as vendorPageLoader,
} from "./pages/vendor/VendorSelectionPage";
import { LoginCallbackPage } from "./_components/login/LoginCallbackPage";
import "bootstrap/dist/css/bootstrap.min.css";
import { RedirectToFirstVendor } from "./RedirectToFirstVendor";
import { ProtectedPageContainer } from "./ProtectedPageContainer";
import {
  VendorMessagesPage,
  loader as vendorMessagesLoader,
  postMessage,
} from "./pages/message/$purchaseOrderItemId/VendorMessagesPage";
import { DefaultErrorElement } from "./_components";

const routes = [
  {
    element: <App />,
    children: [
      { index: true, element: <LoginPage /> },
      { path: "loginCallback", element: <LoginCallbackPage /> },
      {
        // All children will be protected routes and require the user to login
        element: <ProtectedPageContainer />,
        errorElement: <DefaultErrorElement />,
        children: [
          {
            path: "vendor",
            id: "vendor", // this id is how the RedirectToFirstVendor uses the vendorPageLoader to redirect
            loader: vendorPageLoader,
            element: <VendorSelectionPage />,
            children: [
              // This component will redirect the user to the first (or only) vendor available to them, landing on VendorPoItemsPage
              { index: true, element: <RedirectToFirstVendor /> },
              {
                path: ":vendorId",
                element: <VendorPoItemsPage />,
                loader: vendorPoItemsPageLoader,
                children: [
                  {
                    path: "purchaseOrderItem/:purchaseOrderItemId",
                    element: <PurchaseOrderItemExpand />,
                    loader: purchaseOrderItemExpandLoader,
                  },
                ],
              },
            ],
          },
          {
            path: "vendor/:vendorId/purchaseOrderItem/:purchaseOrderItemId/messages",
            loader: vendorMessagesLoader,
            action: postMessage,
            element: <VendorMessagesPage />,
          },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Authenticator.Provider>
      <RouterProvider router={router} />
    </Authenticator.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
